import React from 'react';
import { Section } from './ui/Section';
import { Heart, CheckCircle2, Users, Sparkles, Hand } from 'lucide-react';
export function AboutCreator() {
  return <Section background="cream" className="relative overflow-hidden" data-id="element-23">
      {/* Subtle background decorations */}
      <div className="absolute top-10 right-10 text-[#4AAAA5] opacity-10" data-id="element-24">
        <Sparkles className="w-20 h-20" data-id="element-25" />
      </div>
      <div className="absolute bottom-10 left-10 text-[#F5C842] opacity-10" data-id="element-26">
        <Heart className="w-16 h-16" data-id="element-27" />
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-28">
        <div className="bg-white rounded-3xl p-8 md:p-10 shadow-lg border-2 border-[#E6F4F4]" data-id="element-29">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8" data-id="element-30">
            {/* Avatar / Photo placeholder */}
            <div className="flex-shrink-0" data-id="element-31">
              <div className="relative" data-id="element-32">
                {/* Circular avatar container */}
                <div className="w-36 h-36 md:w-44 md:h-44 rounded-full bg-gradient-to-br from-[#E6F4F4] to-[#D4EFED] border-4 border-white shadow-xl flex items-center justify-center overflow-hidden" data-id="element-33">
                  <img src="https://cdn.magicpatterns.com/uploads/jvgV4ZtMGWgS4SCNhsSRUq/hf_20260205_040115_7c248c9c-8a1a-4f8d-b783-966b7d9ac977.png" alt="Jane - Creadora de CrianzaFeliz" className="w-full h-full object-cover" data-id="element-34" />
                </div>
                {/* Small decorative badge */}
                <div className="absolute -bottom-2 -right-2 bg-gradient-to-r from-[#F5C842] to-[#FFD966] p-2 rounded-full shadow-md" data-id="element-35">
                  <Heart className="w-5 h-5 text-white fill-current" data-id="element-36" />
                </div>
              </div>
            </div>

            {/* Text content */}
            <div className="flex-1 text-center md:text-left" data-id="element-37">
              <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center justify-center md:justify-start gap-2" data-id="element-38">
                Hola, soy <span className="text-[#4AAAA5]" data-id="element-39">Jane</span>
                <Hand className="w-6 h-6 text-[#F5C842]" data-id="element-40" />
              </h2>

              <div className="space-y-4 text-gray-600 leading-relaxed" data-id="element-41">
                <p data-id="element-42">
                  Creé este sistema porque en mi casa la mañana era una batalla:
                  vestir, dientes, mochilas, salida…{' '}
                  <span className="font-semibold text-gray-700" data-id="element-43">
                    todo terminaba en tensión
                  </span>
                  .
                </p>

                <p data-id="element-44">
                  Al principio lo armé para mis hijos y lo compartí con otras
                  mamás. Y cuando empezaron a escribirnos desde distintos
                  lugares, lo convertimos en{' '}
                  <span className="font-semibold text-[#4AAAA5]" data-id="element-45">
                    digital e imprimible
                  </span>
                  , para que cualquier familia pudiera tenerlo sin envíos y sin
                  esperar.
                </p>

                <p data-id="element-46">
                  Además, puedes{' '}
                  <span className="font-bold text-[#E8845F]" data-id="element-47">
                    personalizarlo con el nombre de tu hijo
                  </span>{' '}
                  e imprimirlo en minutos.
                </p>
              </div>

              {/* Small trust indicators */}
              <div className="flex flex-wrap justify-center md:justify-start gap-4 mt-6" data-id="element-48">
                <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-49">
                  <CheckCircle2 className="w-4 h-4 text-[#4AAAA5]" data-id="element-50" />
                  <span data-id="element-51">Mamá de 2</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-52">
                  <Users className="w-4 h-4 text-[#4AAAA5]" data-id="element-53" />
                  <span data-id="element-54">+1,000 familias</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-55">
                  <Heart className="w-4 h-4 text-[#E8845F]" data-id="element-56" />
                  <span data-id="element-57">Hecho con amor</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}